// AdminAnalytics.js
import React from "react"
import { CircularProgressbar, buildStyles } from "react-circular-progressbar"
import "react-circular-progressbar/dist/styles.css"
import "../styles/AdminAnalytics.css"

const AdminAnalytics = ({ stats }) => {
  const formatValue = (stat) => {
    switch (stat.title) {
      case "Total Sales":
        return `$${stat.value.toLocaleString()}`
      case "Site Visits":
        return `${stat.value.toLocaleString()} Hits`
      case "Searches":
        return `${stat.value.toLocaleString()} Queries`
      default:
        return stat.value
    }
  }

  return (
    <div className="analytics-container">
      {stats.map((stat, index) => (
        <div className="analytics-card" key={index}>
          <div className="analytics-figure">
            <CircularProgressbar
              value={stat.percentage}
              text={`${stat.percentage}%`}
              styles={buildStyles({
                pathColor: stat.percentage > 0 ? "#4CAF50" : "#F44336",
                textColor: "black",
                trailColor: "#d6d6d6",
              })}
            />
          </div>
          <div className="analytics-title">{stat.title}</div>
          <div className="analytics-value">{formatValue(stat)}</div>
          <div className="analytics-desc">
            {Math.abs(stat.percentage)}% more than last month
          </div>
        </div>
      ))}
    </div>
  )
}

export default AdminAnalytics
